import ChartWidgetWrapper from './ChartWidgetWrapper';

export default ChartWidgetWrapper;
